    (function () {

        "use strict";


    // ==========================================
    // BEENOUGH MODAL
    // ==========================================

    class BeenoughModal {

        constructor(element) {

        this.modal = element;

    this.dialog =
    element.querySelector(
    ".beenough-modal__dialog"
    );

    this.backdrop =
    element.querySelector(
    ".beenough-modal__backdrop"
    );

    this.closeButtons =
    element.querySelectorAll(
    '[data-beenough-dismiss="modal"]'
    );
                }


    // --------------------------------------
    // SHOW
    // --------------------------------------

    show() {

        this.modal.classList.add("show");

    this.modal.setAttribute(
    "aria-hidden",
    "false"
    );

    document.body.classList.add(
    "beenough-modal-open"
    );
                }


    // --------------------------------------
    // HIDE
    // --------------------------------------

    hide() {

        this.modal.classList.remove("show");

    this.modal.setAttribute(
    "aria-hidden",
    "true"
    );

    document.body.classList.remove(
    "beenough-modal-open"
    );
                }


    // --------------------------------------
    // TOGGLE
    // --------------------------------------

    toggle() {

                    if (
    this.modal.classList.contains("show")
    ) {

        this.hide();

                    } else {

        this.show();

                    }
                }
            }


    // ==========================================
    // MODAL MANAGER
    // ==========================================

    const Beenough = {

        Modal: {

        instances: new Map(),


    getInstance(element) {

                        if (
    !this.instances.has(element)
    ) {

        this.instances.set(
            element,
            new BeenoughModal(element)
        );

                        }

    return this.instances.get(element);
                    },


    getOrCreateInstance(element) {

                        return this.getInstance(element);
                    }
                }
            };


    // ==========================================
    // DATA API
    // ==========================================

    document.addEventListener(
    "click",
    function (event) {

                    const trigger =
    event.target.closest(
    '[data-beenough-toggle="modal"]'
    );


    // ------------------------------
    // OPEN
    // ------------------------------

    if (trigger) {

                        const targetSelector =
    trigger.getAttribute(
    "data-beenough-target"
    );


    const modal =
    document.querySelector(
    targetSelector
    );


    if (!modal) {

        console.error(
            "Beenough Modal not found:",
            targetSelector
        );

    return;
                        }


    const instance =
    Beenough.Modal
    .getOrCreateInstance(modal);


    instance.show();

    return;
                    }


    // ------------------------------
    // CLOSE
    // ------------------------------

    const closeButton =
    event.target.closest(
    '[data-beenough-dismiss="modal"]'
    );


    if (closeButton) {

                        const modal =
    closeButton.closest(
    ".beenough-modal"
    );


    if (modal) {

        Beenough.Modal
            .getInstance(modal)
            .hide();
                        }

    return;
                    }


    // ------------------------------
    // BACKDROP
    // ------------------------------

    if (
    event.target.classList.contains(
    "beenough-modal__backdrop"
    )
    ) {

                        const modal =
    event.target.closest(
    ".beenough-modal"
    );


    if (modal) {

        Beenough.Modal
            .getInstance(modal)
            .hide();
                        }
                    }

                }
    );


    // ==========================================
    // ESCAPE
    // ==========================================

    document.addEventListener(
    "keydown",
    function (event) {

                    if (event.key !== "Escape") {
                        return;
                    }


    const modal =
    document.querySelector(
    ".beenough-modal.show"
    );


    if (modal) {

        Beenough.Modal
            .getInstance(modal)
            .hide();
                    }

                }
    );


    // ==========================================
    // GLOBAL ACCESS
    // ==========================================

    window.Beenough = Beenough;

        })();